<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header
      [header]="data.header"
      [subheader]="data.subheader"
      [imageUrl]="data.avatar_url"
    />
  </ng-container>

  <ng-container body>
    <email-snippet [label]="'Helper: Button - default'">
      <email-button [href]="data.some_link.href" [label]="data.some_link.label" />
    </email-snippet>

    <email-snippet [label]="'Helper: Button - default - inline'">
      <email-button [href]="data.some_link.href" [label]="data.some_link.label" [inline]="true" />
    </email-snippet>

    <email-snippet [label]="'Helper: Button - primary'">
      <email-button [href]="data.some_link.href" [label]="data.some_link.label" theme="primary" />
    </email-snippet>

    <email-snippet [label]="'Helper: Button - primary - inline'">
      <email-button
        [href]="data.some_link.href"
        [label]="data.some_link.label"
        theme="primary"
        [inline]="true"
      />
    </email-snippet>

    <email-snippet [label]="'Helper: Button - danger'">
      <email-button [href]="data.some_link.href" [label]="data.some_link.label" theme="danger" />
    </email-snippet>

    <email-snippet [label]="'Helper: Button - danger - inline'">
      <email-button
        [href]="data.some_link.href"
        [label]="data.some_link.label"
        theme="danger"
        [inline]="true"
      />
    </email-snippet>

    <email-snippet [label]="'Helper: Button - plain'">
      <email-button [href]="data.some_link.href" [label]="data.some_link.label" theme="accent" />
    </email-snippet>

    <email-snippet [label]="'Helper: Button - plain - inline'">
      <email-button
        [href]="data.some_link.href"
        [label]="data.some_link.label"
        theme="accent"
        [inline]="true"
      />
    </email-snippet>

    <email-snippet [label]="'Helper: Infobox - info'">
      <email-infobox [contents]="data.infobox_html" [theme]="'info'" [wrapperTag]="'p'" />
    </email-snippet>

    <email-snippet [label]="'Helper: Infobox - warning'">
      <email-infobox [contents]="data.infobox_html" [theme]="'warning'" [wrapperTag]="'p'" />
    </email-snippet>

    <email-snippet [label]="'Helper: Infobox - success'">
      <email-infobox [contents]="data.infobox_html" [theme]="'success'" [wrapperTag]="'p'" />
    </email-snippet>

    <email-snippet [label]="'Helper: Infobox - critical'">
      <email-infobox [contents]="data.infobox_html" [theme]="'critical'" [wrapperTag]="'p'" />
    </email-snippet>

    <email-snippet [label]="'Helper: Codebox'">
      <email-codebox [code]="data.activation_code" [inline]="true" />
    </email-snippet>

    <email-snippet [label]="'Helper: Candidates reports'">
      <email-candidates-reports
        [reports]="data.daily_reports"
        [headerLinkLabel]="data.some_link.label"
      />
    </email-snippet>

    <email-snippet [label]="'Helper: GDPR reports'">
      <email-gdpr-reports [reports]="data.gdpr_reports" />
    </email-snippet>

    <email-snippet [label]="'Partial: Checkmark'">
      <email-checkmark />
    </email-snippet>
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.footer" color="light" presetName="inline" size="small" />
  </ng-container>
</email-layout>
